<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mzp9Ii/tc-custom/9781035834563.jpg?1705541208823" alt="This image is the cover for the book The Journey of the Trollop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Journey of the Trollop
      </h1>
      <p class="bookDescription body article font2">
        <p>In The Journey of the Trollop, Isabella is the embodiment of resilience and transformation. Mastering the art of reinvention, she fiercely guards her narratives, bending truths to preserve her crafted reality. With an unwavering spirit, she demonstrates that adversity is merely a challenge to overcome. Fearlessly diving into the depths of hardship, Isabella emerges time and again, proving that from nothing, one can create everything.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vicki Kelly
      </h2>
      
      <p class="authorDescription body article">Vicki Kelly lived the first part of her life in New Zealand before moving to the UK in 2004. She has previously worked as a teacher, a farmer, a gardener, a caterer and holds a master’s degree in environmental law. She has four grown-up children, half a dozen grandchildren and a Jack Russell terrier. She is married to Peter Watson.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6baa1d12